"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getDatasetSchema", {
  enumerable: true,
  get: function get() {
    return _getDatasetSchema.default;
  }
});
Object.defineProperty(exports, "getFaqSchema", {
  enumerable: true,
  get: function get() {
    return _getFaqSchema.default;
  }
});
Object.defineProperty(exports, "getInsuranceOfferV2Schema", {
  enumerable: true,
  get: function get() {
    return _getInsuranceOfferV2Schema.default;
  }
});
Object.defineProperty(exports, "getMinimumStarRatingOnSERPsSchema", {
  enumerable: true,
  get: function get() {
    return _getMinimumStartRatingOnSerpsSchema.default;
  }
});
exports.getOrganizationSchema = void 0;
Object.defineProperty(exports, "getReviewRatingSchema", {
  enumerable: true,
  get: function get() {
    return _getReviewRatingSchema.default;
  }
});
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _constants = require("../constants");
var _getDatasetSchema = _interopRequireDefault(require("./get-dataset-schema"));
var _getFaqSchema = _interopRequireDefault(require("./get-faq-schema"));
var _getInsuranceOfferV2Schema = _interopRequireDefault(require("./get-insurance-offer-v2-schema"));
var _getMinimumStartRatingOnSerpsSchema = _interopRequireDefault(require("./get-minimum-start-rating-on-serps-schema"));
var _getReviewRatingSchema = _interopRequireDefault(require("./get-review-rating-schema"));
/**
 * Get the schema for Organization
 *
 * @return {Object} Organization schema
 */
var getOrganizationSchema = exports.getOrganizationSchema = function getOrganizationSchema() {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _constants.CONTEXT), _constants.ORGANIZATION);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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